export const getUrlParameterText = (
  search = typeof window !== "undefined" ? window.location.search : ""
) => new URLSearchParams(search).toString();
